import React, {Dispatch, SetStateAction, useCallback} from 'react';

import {DebouncedDateInput} from '../shared';

const DateFilter = <T extends string, F extends Partial<Record<T, Date>>>({
    id,
    label,
    field,
    filters,
    setFilters,
}: {
    id: string;
    label: string;
    field: T;
    filters: F;
    setFilters: Dispatch<SetStateAction<F>>;
}): JSX.Element => {
    const handleChange = useCallback(
        (value: Date | undefined) => {
            setFilters(filters => ({...filters, [field]: value}));
        },
        [field, setFilters]
    );

    return (
        <DebouncedDateInput
            id={id}
            value={filters[field]}
            onChange={handleChange}
            label={label}
        />
    );
};

export default DateFilter;
